import React from 'react';
import { useTheme } from '@24i/nxg-sdk-higgs';
import { View, Text } from '@24i/nxg-sdk-quarks';
import PackshotGrid from '@24i/nxg-sdk-gluons/src/components/containers/PackshotGrid';
import Loader from '@24i/nxg-sdk-gluons/src/components/ui/Loader';
import getSeeAllScreenStyles from '../styles/index.web';
import { SeeAllScreenWebProps, SEE_ALL_TEST_IDS } from '../types';

const SeeAllScreen = ({
    assets,
    assetsLabel,
    styles: getStyles = getSeeAllScreenStyles,
    isLoading,
    gridContainerRef,
    displayType,
    handlePackshotPress,
}: SeeAllScreenWebProps) => {
    const { theme } = useTheme();
    const styles = getStyles(theme);

    return (
        <View style={styles.holder} ref={gridContainerRef} testID={SEE_ALL_TEST_IDS.CONTAINER}>
            <View style={styles.pickerHolder}>
                <Text style={styles.sectionTitle} testID={SEE_ALL_TEST_IDS.TITLE}>
                    {assetsLabel}
                </Text>
            </View>
            {/* @ts-ignore */}
            <PackshotGrid
                items={assets}
                onItemPress={handlePackshotPress}
                displayType={displayType}
            />
            {isLoading && <Loader />}
        </View>
    );
};

export default SeeAllScreen;
